












import Vue from "vue";
import iwInputText from "../../buildingBlocks/InputText.vue";
import { mapGetters } from "vuex";

export default Vue.extend({
    components: {
        iwInputText: iwInputText
    },
    data: function() {
        return {
            pathInStore: "property.location.address.floor",
        };
    },
    computed: {
        ...mapGetters({
            isReadonlyField: "FormModule/isReadonlyField",
            editNotAllowed: "FormModule/editNotAllowed"
        }),
        floor: function(): string | null {
            return this.$store.getters["FormModule/getValue"](this.pathInStore) ? (this.$store.getters["FormModule/getValue"](this.pathInStore)).toString() : null;
        },
        isOptional: function(): boolean {
            return ["OFFICE", "INDUSTRY", "COMMERCIAL", "GARAGE"].indexOf(this.getPropertyType()) !== - 1;
        }
    },
    mounted: function() {
        if (this.$store.getters["FormModule/getValue"](this.pathInStore) == null) {
            this.$store.commit("FormModule/deleteValue", this.pathInStore);
        }
    },
    methods: {
        updateText: function (event: Event) {
            const target = event.target as HTMLInputElement;
            const value = target.value;

            if (value == "") {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {path: this.pathInStore, value: parseInt(value)});
            }
        },
    }

});
